module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "white_bg",
    attrs: {
      "id": "rooms"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.title != null) ? _c('div', {
    staticClass: "main_title mt_wave a_center"
  }, [_c('h2', [_vm._v(_vm._s(_vm.title[_vm.currentLanguage]))])]) : _vm._e(), _vm._v(" "), (_vm.header != null) ? _c('p', {
    staticClass: "main_description a_center"
  }, [_vm._v("\n            " + _vm._s(_vm.header[_vm.currentLanguage]) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.favorites), function(room) {
    return _c('favorite-room', {
      key: room.id,
      attrs: {
        "room": room
      }
    })
  })), _vm._v(" "), (_vm.rooms.length > _vm.favorites.length) ? _c('div', {
    staticClass: "mt40 a_center"
  }, [_c('router-link', {
    directives: [{
      name: "lang",
      rawName: "v-lang.view_room_list",
      modifiers: {
        "view_room_list": true
      }
    }],
    staticClass: "button btn_sm btn_yellow uppercase",
    attrs: {
      "to": "/site/rooms"
    }
  })], 1) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-598f166a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/favoriteRooms/favoriteRooms.vue
// module id = 369
// module chunks = 0